import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext'; // Importe o AuthProvider


const root = ReactDOM.createRoot(document.getElementById('root'));
const hostname = window.location.hostname;
let subdomain = hostname.split('.')[0];

// Formata subdomínio com traço: primeira palavra capitalizada, segunda toda maiúscula
subdomain = subdomain
  .split('-')
  .map((word, index) => index === 0
    ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()  // primeira palavra capitalizada
    : word.toUpperCase()  // palavras seguintes totalmente maiúsculas
  )
  .join('-');

document.title = `Gerencial ${subdomain || ''}`;
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
